import React, {useEffect, useState } from 'react';
import { Container, Row, Col, Card, Button, ButtonGroup } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './styles/projects.css';


const Projects = () => {
    const projectData = 
        [
            {
                name: 'Appointment Booking System',
                emoji: '📅',
                sub_title: 'Hairstyling Appointment Schedule',
                paragraph: 'We developed a custom booking system for a Hairstyling salon allowing the customer to completely customise their booking system and have it tailored to fit their needs',
                points: [
                    'Reduced no-shows by allowing customer to charge a % of booking fee',
                    'Automated email / sms reminders',
                    'Calendar integration for both customer / users'
                ],
                technologies: [
                    'React.js',
                    'Node.js',
                    'MariaDB',
                    'SASS',
                    'Bootstrap',
                    'Stripe',
                    'Paypal'
                ]
            },
            {
                name: 'Appointment Booking System',
                emoji: '📅',
                sub_title: 'Hairstyling Appointment Schedule',
                paragraph: 'We developed a custom booking system for a Hairstyling salon allowing the customer to completely customise their booking system and have it tailored to fit their needs',
                points: [
                    'Reduced no-shows by allowing customer to charge a % of booking fee',
                    'Automated email / sms reminders',
                    'Calendar integration for both customer / users'
                ],
                technologies: [
                    'React.js',
                    'Node.js',
                    'MariaDB',
                    'SASS',
                    'Bootstrap',
                    'Stripe',
                    'Paypal'
                ]
            }
        ]

        const projectDataSecond = 
        [
            {
                name: 'Appointment Booking System',
                emoji: '📅',
                sub_title: 'Hairstyling Appointment Schedule',
                paragraph: 'We developed a custom booking system for a Hairstyling salon allowing the customer to completely customise their booking system and have it tailored to fit their needs',
                technologies: [
                    'React.js',
                    'Node.js',
                    'MariaDB',
                    'SASS',
                    'Bootstrap',
                    'Stripe',
                    'Paypal'
                ]
            },
            {
                name: 'Appointment Booking System',
                emoji: '📅',
                sub_title: 'Hairstyling Appointment Schedule',
                paragraph: 'We developed a custom booking system for a Hairstyling salon allowing the customer to completely customise their booking system and have it tailored to fit their needs',
                technologies: [
                    'React.js',
                    'Node.js',
                    'MariaDB',
                    'SASS',
                    'Bootstrap',
                    'Stripe',
                    'Paypal'
                ]
            },
            {
                name: 'Appointment Booking System',
                emoji: '📅',
                sub_title: 'Hairstyling Appointment Schedule',
                paragraph: 'We developed a custom booking system for a Hairstyling salon allowing the customer to completely customise their booking system and have it tailored to fit their needs',
                technologies: [
                    'React.js',
                    'Node.js',
                    'MariaDB',
                    'SASS',
                    'Bootstrap',
                    'Stripe',
                    'Paypal'
                ]
            }
        ]

 return (
    <div className='projects'>
        <Container className='my-5'>
            <h2 className='projects-title'>Our Projects.📋</h2>
            <p className='sub-title'>Here's some insight into our most recent projects, so you can see what we have worked on and how we have helped existing customers.</p>

            <Row>
                {projectData.map((projectData, index) => 
                    <Col key={index} xs={12} md={6} lg={6} className='mb-4'>
                        <Card className='h-100'>
                            <Card.Title className='project-title'>
                                    <h1>{projectData.emoji}</h1>
                                    <h3>{projectData.name}</h3>
                            </Card.Title>
                            <Card.Body className='d-flex flex-column'>
                                    <h5>{projectData.sub_title}</h5>
                                <Card.Text>
                                    <p>{projectData.paragraph}</p>
                                </Card.Text>
                                <ul className='project-details'>
                                    {projectData.points.map((technology, idx) => (
                                        <li key={idx}>
                                            {technology}
                                        </li>
                                    ))}
                                </ul>
                                <div className='tech-tags mt-3'>
                                    {projectData.technologies.map((tech) => (
                                        <span key={tech} className='tech-tag'>
                                            {tech}
                                        </span>
                                    ))}
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                )}
            </Row>
            <Row>
                {projectDataSecond.map((projectDataSecond, index) => 
                    <Col key={index} xs={12} md={4} lg={4} className='mb-4'>
                        <Card className='h-100'>
                            <Card.Title className='project-title'>
                                    <h1>{projectDataSecond.emoji}</h1>
                                    <h3>{projectDataSecond.name}</h3>
                            </Card.Title>
                            <Card.Body className='d-flex flex-column'>
                                    <h5>{projectDataSecond.sub_title}</h5>
                                <Card.Text>
                                    <p>{projectDataSecond.paragraph}</p>
                                </Card.Text>
                                <div className='tech-tags mt-3'>
                                    {projectDataSecond.technologies.map((tech) => (
                                        <span key={tech} className='tech-tag'>
                                            {tech}
                                        </span>
                                    ))}
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                )}
            </Row>
        </Container>
    </div>
 )
}


export default Projects;